
export const OPEN_DOWNLOAD_ALERT = 'OPEN_DOWNLOAD_ALERT';

